import { useContext } from 'react';

import { WhatsNewContext } from './whats-new-context';

export const useWhatsNew = () => useContext(WhatsNewContext);
